import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {SendAppNotificationInitiateDto} from '../../dtos/sendAppNotificationInitiateDto';
import {FirebaseNotificationTaskProgressReport} from '../../dtos/firebaseNotificationTaskProgressReport';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SendAppNotificationService {

    constructor(private _httpClient: HttpClient) {}

    public progress(): Observable<FirebaseNotificationTaskProgressReport> {
        return this._httpClient.get<any>(environment.apiUrl + 'api/integration/firebase/admin/messaging/v1/progress')
            .pipe(map(resp => new FirebaseNotificationTaskProgressReport().deserialize(resp)));
    }

    public initiate(initiateDto: SendAppNotificationInitiateDto): Observable<FirebaseNotificationTaskProgressReport> {
        return this._httpClient.post<any>(environment.apiUrl + 'api/integration/firebase/admin/messaging/v1/initiate',
            initiateDto)
            .pipe(map(resp => new FirebaseNotificationTaskProgressReport().deserialize(resp)));
    }
}
